import './SiteSearchForm.scss';

import classnames from 'classnames';
import { push } from 'connected-react-router';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { connect } from 'react-redux';

import FieldsWrapper from './components/FieldsWrapper';
import FormWrapper from './components/FormWrapper';
import validationSchema from './schema.js';

const propTypes = {
  layout: PropTypes.oneOf(['', 'page', 'line']),
  children: PropTypes.node,
  className: PropTypes.string,
  onSubmit: PropTypes.func,
  // store
  push: PropTypes.func.isRequired
};

const SiteSearchForm = ({
  layout = 'page',
  children,
  className,
  onSubmit,
  push
}) => {
  const searchInput = useRef(null);
  useEffect(() => {
    searchInput.current.focus();
  });
  const { handleSubmit, handleChange, values } = useFormik({
    initialValues: {
      term: ''
    },
    validationSchema,
    onSubmit(values, { resetForm }) {
      const { term } = values;

      typeof onSubmit === 'function' && onSubmit(term);

      resetForm();

      push(`/search/${encodeURIComponent(term)}/`);
    }
  });
  return (
    <div className={classnames('site-search-form', className)}>
      <FormWrapper layout={layout}>
        <Form inline={layout === 'line'} onSubmit={handleSubmit}>
          <FieldsWrapper layout={layout}>
            <Form.Control
              ref={searchInput}
              type="text"
              name="term"
              className=""
              placeholder="Search..."
              onChange={handleChange}
              value={values.term}
            />
          </FieldsWrapper>
          <Button
            type="submit"
            variant={layout === 'line' ? 'default' : 'primary'}
            className="primary-form-action"
          >
            {layout === 'page' && 'Search'}
          </Button>
          {children}
        </Form>
      </FormWrapper>
    </div>
  );
};

SiteSearchForm.propTypes = propTypes;

export default connect(null, { push })(SiteSearchForm);
